import { ETextStyleVariant, Text } from '@outdoorsyco/bonfire';

import ResponsiveImage from '@/components/utility/ResponsiveImage/ResponsiveImage';

export type TPromoBanner = {
  bannerIcon?: string;
  bannerText?: string;
};

export const PromoBanner = ({ bannerIcon, bannerText }: TPromoBanner) => {
  if (!bannerIcon || !bannerText) return;
  return (
    <div className="flex items-center justify-center py-2 bg-gray-800 gap-2">
      <ResponsiveImage src={bannerIcon} alt="banner icon" />
      <Text variant={ETextStyleVariant.MediumRegular} className="text-white">
        {bannerText}
      </Text>
    </div>
  );
};
